import {
  FETCH_FOREX_COMPANIES_REQUEST,
  FETCH_FOREX_COMPANIES_SUCCESS,
  FETCH_FOREX_COMPANIES_FAILURE,
} from 'actionTypes';

import createReducer from './createReducer';

const initialState = {
  entities: {},
  ids: [],
  isFetching: false,
  isRequestFailed: false,
  isLoaded: false,
};

const FOREX_COMPANIES = createReducer(initialState, {
  [FETCH_FOREX_COMPANIES_REQUEST]: state => ({
    ...state,
    entities: {},
    ids: [],
    isFetching: true,
    isRequestFailed: false,
    isLoaded: false,
  }),

  [FETCH_FOREX_COMPANIES_SUCCESS]: (state, action) => ({
    ...state,
    entities: action.payload.entities,
    ids: action.payload.ids,
    isFetching: false,
    isLoaded: true,
  }),

  [FETCH_FOREX_COMPANIES_FAILURE]: state => ({
    ...state,
    isFetching: false,
    isRequestFailed: true,
  }),
});

export default FOREX_COMPANIES;
